<template>
  <div class="header">
    <div class="profile-menu" v-click-outside="closeDropdown">
      <div class="profile-avatar" @click="toggleDropdown">{{ getFirstLetter(userProfile.first_name) }}</div>
      <div class="dropdown" v-if="showDropdown">
        <button class="dropdown-item" @click="logout">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      userProfile: [],
      showDropdown: false,
    };
  },
  async mounted() {
    this.userProfile = await this.profile();
  },
  methods: {
    ...mapActions(["profile", "clearToken"]),
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    goToDashboard() {
      this.$router.push({ path: "/mtclab/dashboard" });
    },
    logout() {
      this.showDropdown = false;
      this.clearToken().then(() => {
        this.$router.push({ path: "/login" });
      });
    },
    getFirstLetter(name) {
      return name ? name.charAt(0).toUpperCase() : "";
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  position: absolute;
  right: 60px;
  top: 0;
  height: 100%;
  align-items: center;
}

.profile-menu {
  position: relative;
  cursor: pointer;
}

.profile-avatar {
  width: 40px;
  height: 40px;
  background-color: #005EB8;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}

.dropdown {
  position: absolute;
  top: 50px;
  right: -43px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 120px;
  z-index: 100;
}

.dropdown-item {
  width: 100%;
  padding: 10px;
  text-align: left;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #005eb8;
  font-family: TTNormsMedium, sans-serif;
}

.dropdown-item:hover {
  background-color: #f4f4f5;
}
</style>
